import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-mapa-latlng-cliente-dialog',
  templateUrl: './mapa-latlng-cliente-dialog.component.html',
  styleUrls: ['./mapa-latlng-cliente-dialog.component.scss', '../../../styles/estilo.padrao.scss']
})
export class MapaLatlngClienteDialog implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<MapaLatlngClienteDialog>,
    @Inject(MAT_DIALOG_DATA) public data: { latitude: number, longitude: number }
  ) { }

  ngOnInit(): void {
  }

  onMapReady(map) {
    map.setOptions({
      streetViewControl: false,
      draggable: false,
      keyboardShortcuts: false,
      minZoom: 13
    });
  }

  cancelar() {
    this.dialogRef.close();
  }

}
